import { DEBUG_MODE } from "./developer";
import { LOCAL_STORAGE_KEYS } from "../models/localStorage";
const LOG_PREFIX_NAME: string = process.env.REACT_APP_LOG_PREFIX;

const STRINGIFY: boolean = (function stringify(): boolean {
	const stringify = localStorage.getItem(LOCAL_STORAGE_KEYS.DEBUG_MODE_STRINGIFY);
	return stringify && stringify === "true";
})();

// exclude formatted logs
function isFormatted(...x): boolean {
	return x && x.length && x[0] && x[0].indexOf && x[0].indexOf("%c") > -1;
}

// override console.log for production
if (process.env.NODE_ENV === "production" && !DEBUG_MODE) {
	const overrideLogFn = () => {};
	window.console.log = overrideLogFn;
	window.console.info = overrideLogFn;
	window.console.debug = overrideLogFn;
	window.console.error = overrideLogFn;
	window.console.warn = overrideLogFn;
	window.console.table = overrideLogFn;
	window.console.group = overrideLogFn;
	window.console.groupCollapsed = overrideLogFn;
	window.console.groupEnd = overrideLogFn;
} else {
	// style for debug mode
	const logFn = console.log;
	const debugFn = console.debug;
	const infoFn = console.info;
	const errorFn = console.error;

	const logDate = (now = new Date()) =>
		`[${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}.${now.getMilliseconds()}]`;
	const logWithFormattedData = (logPrefix: string, logParams: string, logFnParam, ...x) => {
		let hasArrayData: boolean = false;
		if (STRINGIFY) {
			logFnParam(logPrefix, logParams, ...x);
			return;
		}
		x.forEach((arg) => {
			if (Array.isArray(arg)) {
				hasArrayData = true;
			}
		});
		if (hasArrayData) {
			let title: string = logPrefix;
			let skipFirst: boolean = false;
			if (x[0] && typeof x[0] === "string") {
				title += " " + x[0] + " **************************** DATA: ";
				skipFirst = true;
			}
			console.groupCollapsed(title, logParams);
			x.forEach((arg, i) => {
				if (!skipFirst || i !== 0) {
					if (Array.isArray(arg)) {
						console.table(arg);
					} else {
						logFnParam(arg);
					}
				}
			});
			console.groupEnd();
		} else {
			logFnParam(logPrefix, logParams, ...x);
		}
	};

	const appLogFn = (...x) => {
		if (isFormatted(...x)) {
			logFn(...x);
		} else {
			logWithFormattedData(`%c${LOG_PREFIX_NAME} Log: ${logDate()}`, "color:#1994db;", logFn, ...x);
			// logFn(`%c${LOG_PREFIX_NAME} Log: ${logDate()}`, "color:blue;", ...x);
		}
	};
	const appDebugFn = (...x) => {
		// debugFn(`%c${LOG_PREFIX_NAME} Debug: ${logDate()}`, "color:purple;", ...x);
		if (isFormatted(...x)) {
			debugFn(...x);
		} else {
			logWithFormattedData(`%c${LOG_PREFIX_NAME} Debug: ${logDate()}`, "color:purple;", debugFn, ...x);
		}
		// logger.debug(...x);
	};
	const appInfoFn = (...x) => {
		// logger.info(...x);
		if (isFormatted(...x)) {
			infoFn(...x);
		} else {
			// infoFn(`%c${LOG_PREFIX_NAME} Info: ${logDate()}`, "color:blue;", ...x);
			logWithFormattedData(`%c${LOG_PREFIX_NAME} Info: ${logDate()}`, "color:blue;", infoFn, ...x);
		}
	};
	const appErrorFn = (...x) => {
		errorFn(`%c${LOG_PREFIX_NAME} Error: ${logDate()}`, "color:red; font-weight: bold", ...x);
		// logger.error(...x);
	};
	window.console.log = appLogFn;
	window.console.info = appInfoFn;
	window.console.debug = appDebugFn;
	window.console.error = appErrorFn;
}

export function logMethod(target, key, descriptor) {
	let componentName: string = "";
	if (target && target.constructor) {
		componentName = target.constructor.name;
	}
	if (descriptor === undefined) {
		descriptor = Object.getOwnPropertyDescriptor(target, key);
	}
	const originalMethod = descriptor.value;
	if (!DEBUG_MODE) return originalMethod;
	descriptor.value = async function (...args) {
		var a = args
			.map(function (a) {
				return STRINGIFY ? JSON.stringify(a) : a;
			})
			.join();
		var result = await originalMethod.apply(this, args);
		var r = STRINGIFY ? JSON.stringify(result) : result;
		console.log(`${componentName} `, key, "(" + a + ") => ", r);
		return result;
	};
	return descriptor;
}
